import ApiService from "common/service/api";
import { map, catchError } from "rxjs/operators";
import { PublicError } from 'common/service/error';


export default class TagsHistoryService extends ApiService {
  constructor(config) {
    super(config);
    this.baseURL = `/api/tags/history`; //For tags, the base URL begins with /api instead of /ui.
  }

  getTagsHistoryByPageNum(deviceId, pageNum, tagsData, limit) {
    const pageLimit = limit === undefined ? 10 : limit;
    return this.fetchTagHistoryResource(`/${deviceId}?page=${pageNum}&limit=${pageLimit}`, pageNum, tagsData === undefined? [] : tagsData);
  }
}
